"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GenerateRubricHandlerEvent () {
        return GenerateRubricHandlerEvent;
    },
    get ReviewCycleCalculateHandlerEvent () {
        return ReviewCycleCalculateHandlerEvent;
    },
    get ScoreReviewCycleHandlerEvent () {
        return ScoreReviewCycleHandlerEvent;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const ReviewCycleCalculateHandlerEvent = _zod.z.object({
    companyId: _utilsisomorphic.transformObjectId,
    reviewCycleId: _utilsisomorphic.transformObjectId,
    actions: _zod.z.enum([
        "unassigned-reports",
        "status"
    ]).array()
});
const GenerateRubricHandlerEvent = _zod.z.object({
    companyId: _utilsisomorphic.transformObjectId,
    formId: _utilsisomorphic.transformObjectId,
    userId: _utilsisomorphic.transformObjectId.optional(),
    formPurpose: _zod.z.string().optional(),
    persist: _zod.z.boolean().optional()
});
const ScoreReviewCycleHandlerEvent = _zod.z.object({
    companyId: _utilsisomorphic.transformObjectId,
    reviewCycleId: _utilsisomorphic.transformObjectId
});
